import { createContext } from 'react';
import { ThemeConfigScheme } from 'hooks/useThemeConfiguration/useThemeConfiguration';
import themeConfig from '../../themeConfig.json';

const ThemeContext = createContext(themeConfig.default as ThemeConfigScheme);

export default ThemeContext;
